import { ColDef, ColumnApi, GridApi, IServerSideDatasource, ServerSideStoreType } from '@ag-grid-community/all-modules';
import '@ag-grid-community/all-modules/dist/styles/ag-grid.css';
import {
  ProcessCellForExportParams,
  ProcessHeaderForExportParams,
} from '@ag-grid-community/core/dist/cjs/interfaces/exportParams';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import { Grid, Paper, Switch, TablePagination } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import * as Sentry from '@sentry/browser';
import { Severity } from '@sentry/types/dist/severity';
import classNames from 'classnames';
import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import '../../../public/styles/TNAGGrid.scss';

import QuickActionButton from '../../_components/QuickActionButton';
import RecentSearch from '../../_components/RecentSearch';
import SearchBar from '../../_components/SearchBar';
import TnButton from '../../_components/tn-button/TnButton';
import { history } from '../../_helpers/history';
import { SelectFilter } from '../../_services/filter/SelectFilter';
import {
  ActiveCandidateStatus,
  APPLICANT,
  CLIENT_REVIEW,
  INTERVIEW,
  MspNewSubmissionCandidateStatus,
  MspPreInterviewCandidateStatus,
  OFFER_ACCEPTED,
  OFFER_EXTENDED,
  ONBOARDING_FINAL,
  ONBOARDING_PREP,
  OnBoardingStatus,
  PRE_SCREEN,
} from '../../constants/CandidateStatus';
import { HMVPActiveContractorStatus } from '../../constants/ContractorStatus';
import { ActiveJobStatus, NotClosedJobStatus, PendingJobStatus } from '../../constants/JobStatus';
import FilterCount from '../filter-count/FilterCount';
import { NameValuePair } from '../NameValuePair';
import TnSelect from '../tn-select/TnSelect';
import TnTypography from '../tn-typography/TnTypography';

import TnAgGridPaginationActions from './TnAgGridPaginationActions';

interface IProps {
  [Key: string]: any;
  rowData: Array<any>;
  columnHeaders: Array<ColDef>;
  keys: Array<string>;
  isCheckboxRequired: boolean;
  isLinkRequired: boolean;
  isButtonequired: boolean;
  length: number;
  linkRequiredIncol: number;
  paginationPageSize: number;
  rowHeight?: number;
  isSideBarRequired?: boolean;
  isSearchRequired?: boolean;
  component?: any;
  iconList?: Array<any>;
  isRowSelectable?: any;
  filterCount?: number;
  filters?: any;
  savedFilters?: any;
  filterValue?: any;
  applyFilter?: string;
  currentPage?: number;
  autoSizeColumns: Array<string>;
  isPrintRequired?: boolean;
  isCSVRequired?: boolean;
  isExcelRequired?: boolean;
  rowGroupPanelShow?: string;
  rowCount?: number;
  isHorizontalScrollRequired?: boolean;
  getJobList?: any;
  viewAll?: boolean;
  skipRefresh?: boolean;
  isAutoSizeToggleRequired?: boolean;
  datasource?: IServerSideDatasource;
  height?: number;
  applyColumnDefOrder?: boolean;
  action?: React.ReactNode;
  searchPlaceholder?: string;
}

interface IState {
  columnDefs: Array<ColDef>;
  modules: Array<any>;
  rowData: Array<any>;
  columnHeaders: Array<ColDef>;
  selectedRows: Array<any>;
  quickFilterText: string;
  rowsOnPage: number;
  sideBar: any;
  recentSearchList: Array<string>;
  defaultColumnDefs: ColDef;
  autoGroupColumnDef: any;
  prevDataSize: number;
  hideSearchBar: boolean;
  isPrintRequired: boolean;
  isCSVRequired: boolean;
  isExcelRequired: boolean;
  iconList: Array<any>;
  height: number;
  filterValue: any;
  colorIndicator: number;
  currentPage: number;
  loader: boolean;
  rowCount: number;
  isActive: boolean;
  groupByColumnsCount: number;
  externalUpdate?: boolean;
  internalUpdate?: boolean;
}

const SEARCH_COLUMN_HEADER: ColDef = {
  field: 'search',
  hide: true,
  lockVisible: true,
  filter: 'agTextColumnFilter',
  filterParams: {
    newRowsAction: 'keep',
  },
};

class TNAGGrid extends Component<IProps, IState> {
  gridApi?: GridApi;
  gridColumnApi?: ColumnApi;

  constructor(props: IProps) {
    super(props);
    this.state = {
      columnDefs: [],
      modules: AllModules,
      rowData: this.props.rowData,
      columnHeaders: [],
      prevDataSize: this.props.rowData?.length ?? 0,
      selectedRows: [],
      rowCount: -1,
      filterValue: null,
      quickFilterText: '',
      rowsOnPage: 25,
      hideSearchBar: this.props.isSearchRequired == undefined ? false : !this.props.isSearchRequired,
      isPrintRequired: this.props.isPrintRequired ? this.props.isPrintRequired : true,
      isCSVRequired: this.props.isCSVRequired ? this.props.isCSVRequired : true,
      isExcelRequired: this.props.isExcelRequired ? this.props.isExcelRequired : true,
      iconList: this.props.iconList ? this.props.iconList : [],
      height: 0,
      colorIndicator: 1,
      sideBar: {
        toolPanels: [
          {
            id: 'columns',
            labelDefault: 'Columns',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
              suppressRowGroups: true,
              // suppressValues: true,
              suppressPivots: true,
              suppressColumnSelectAll: true,
              suppressPivotMode: true,
              suppressColumnFilter: true,
              suppressFilter: true,
              suppressColumnExpandAll: true,
            },
          },
        ],
        sideBarVisible: true,
      },

      defaultColumnDefs: {
        sortable: true,
        resizable: true,
        enableRowGroup: true,
        enablePivot: false,
        enableValue: true,
        filter: 'agTextColumnFilter',
      },
      autoGroupColumnDef: {
        enableRowGroup: false,
        enableValue: false,
      },
      recentSearchList: [],
      currentPage: 0,
      loader: false,
      isActive: this.props.isHorizontalScrollRequired ? this.props.isHorizontalScrollRequired : false,
      groupByColumnsCount: 0,
      externalUpdate: false,
      internalUpdate: false,
    };

    this.onSelectingRow = this.onSelectingRow.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePaginationFromGrid = this.handlePaginationFromGrid.bind(this);
  }

  componentDidMount() {
    const columnHeaders = this.props.columnHeaders;
    if (this.props.datasource) {
      //add an additional "hidden" column to handle SSR searching
      columnHeaders.push(SEARCH_COLUMN_HEADER);
    }

    this.setState({ columnDefs: columnHeaders });
    // this.setState({ rowData: this.props.rowData });
    let rowsOnPage = this.state.rowData.length;
    rowsOnPage = this.props.paginationPageSize > 0 ? this.props.paginationPageSize : rowsOnPage;
    this.setState({ rowsOnPage });
  }

  componentWillReceiveProps(props: IProps) {
    if (!props.datasource) {
      let flag = 0;
      if (
        this.state.prevDataSize === props.rowData.length &&
        JSON.stringify(this.state.rowData) === JSON.stringify(props.rowData)
      ) {
        flag = 1;
      }
      //this.setState({ rowData: props.rowData });
      if (this.gridApi === undefined) {
        this.setState({
          rowData: props.rowData,
          prevDataSize: props.rowData.length,
          selectedRows: [],
        });
      }
      if (flag == 0 && this.gridApi && !props.skipRefresh) {
        this.setState({ rowData: props.rowData, selectedRows: [] }, () => {
          this.setState({ prevDataSize: props.rowData.length });
          if (!this.props.immutableData) {
            this.gridApi && this.gridApi.setRowData([]);
            this.gridApi && this.gridApi.updateRowData({ add: props.rowData });
          }
          if (props.rowData.length > 0) {
            this.state.columnDefs.map((header) => {
              if (header.field) {
                header.filter = SelectFilter(this.state.rowData[0][header.field], header.filter);
              }
            });
          }
          if (!_.isEqual(props.columnHeaders, this.state.columnDefs)) {
            this.gridApi && this.gridApi.setColumnDefs(this.state.columnDefs);
          }
        });
      }
    }

    const columnHeaders = this.props.columnHeaders;
    if (this.props.datasource) {
      //add an additional "hidden" column to handle SSR searching
      columnHeaders.push(SEARCH_COLUMN_HEADER);
    }

    this.setState({ rowData: props.rowData, columnDefs: columnHeaders });

    if (this.props.filters === null && this.props.filterCount !== -1) {
      this.gridApi && this.gridApi.setFilterModel(null);
    }
    if (
      this.gridApi &&
      props.currentPage !== undefined &&
      (this.state.currentPage !== props.currentPage || this.gridApi.paginationGetCurrentPage() !== props.currentPage)
    ) {
      this.setState({ currentPage: props.currentPage });
      this.gridApi.paginationGoToPage(props.currentPage);
    }

    if (this.props.paginationPageSize !== this.state.rowsOnPage) {
      this.setState({ rowsOnPage: this.props.paginationPageSize });
      this.gridApi && this.gridApi.paginationSetPageSize(this.props.paginationPageSize);
    }
    this.setState({ iconList: props.iconList ? props.iconList : [] });

    if (props.datasource && !_.isEqual(props.externalUpdate, this.state.externalUpdate)) {
      this.gridApi?.refreshServerSideStore({ route: [], purge: false });
      this.gridApi?.deselectAll();
      this.setState({ externalUpdate: props.externalUpdate });
    }

    if (props.datasource && !_.isEqual(props.internalUpdate, this.state.internalUpdate)) {
      this.gridApi?.refreshServerSideStore({ route: [], purge: false });
      this.gridApi?.deselectAll();
      this.setState({ internalUpdate: props.internalUpdate });
    }
  }

  getDropdown = () => {
    let rowsOnPage = 0;
    const paginationArray: Array<NameValuePair> = [];
    const totalRows = this.state.rowData.length;
    const paginationPageSize = this.props.paginationPageSize > 0 ? this.props.paginationPageSize : 10;

    while (rowsOnPage <= totalRows) {
      rowsOnPage = rowsOnPage + paginationPageSize;
      paginationArray.push({
        label: rowsOnPage.toString(),
        value: rowsOnPage,
      });
    }

    return (
      <TnSelect
        valueAs={'value'}
        label="Rows Per Page"
        options={paginationArray}
        onChange={(value: any) => this.handleChange(value)}
        value={this.state.rowsOnPage}
        suppressNone={true}
      />
    );
  };

  handleChange = (value: string) => {
    const rowsOnPage = +value;
    // change state only if rowsOnPage value gets changed
    if (rowsOnPage !== this.state.rowsOnPage) {
      this.gridApi && this.gridApi.paginationSetPageSize(rowsOnPage);
      this.setState({ rowsOnPage: rowsOnPage, currentPage: 0 });
      this.props.cascadeRowsOnPage(rowsOnPage);
    }
  };

  filterRow = (row: any, searchWords: any) => {
    let foundAll = true;
    const keys = Object.keys(row);
    searchWords.map((word: Readonly<any>) => {
      let foundOne = false;
      for (let i = 0; i < keys.length; i++) {
        const value = row[keys[i]];
        if (value && value.constructor == {}.constructor) {
          if (this.filterRow(value, searchWords)) foundOne = true;
          break;
        }
        if (value == 'id' || value == '_id') continue;
        if (value && value.toString().toLowerCase().indexOf(word.toLowerCase()) != -1) {
          foundOne = true;
          break;
        }
      }
      if (!foundOne) foundAll = false;
    });

    return foundAll;
  };

  // function for filter input change.
  handleSearch = (searchText: string) => {
    let rowData = this.props.rowData;
    const searchWords = searchText.split(' ');
    if (searchWords.length > 0) {
      rowData = rowData.filter((row) => {
        return this.filterRow(row, searchWords);
      });
      this.setState({ rowData });
    } else {
      this.setState({ rowData: this.props.rowData });
    }
  };

  //display recently searched text
  displayRecentSearch = () => {
    const recentSearchList = this.state.recentSearchList;

    if (!recentSearchList || recentSearchList.length === 0) return null;

    return recentSearchList.map((recentSearch) => {
      return (
        <RecentSearch
          key={recentSearch}
          label={recentSearch}
          onClick={this.handleSearch}
          onClose={this.handleRecentSearchDelete}
        />
      );
    });
  };

  handleRecentSearchDelete = (searchText: string) => {
    let recentSearchList = this.state.recentSearchList;
    if (recentSearchList.includes(searchText)) {
      recentSearchList = recentSearchList.filter((recentSearchText: string) => {
        return recentSearchText !== searchText;
      });
      this.setState({ recentSearchList }, () => {
        if (recentSearchList.length === 0) this.setState({ quickFilterText: '' });
      });
    }
  };

  onBtnPrint = () => {
    this.setPrinterFriendly();
    setTimeout(() => {
      print();
      this.setNormal();
    }, 2000);
  };

  handleDataSourceElasticInput = (quickFilterText: string) => {
    const currentFilterModel = this.gridApi?.getFilterModel() ?? {};
    if (quickFilterText !== '') {
      // 'search' is the field we are using to stash the search text
      const searchFilterModel = {
        search: { filter: quickFilterText, type: 'contains' },
      };
      const newFilterModel = Object.assign(currentFilterModel, searchFilterModel);
      this.gridApi?.setFilterModel(newFilterModel);
      this.gridApi?.onFilterChanged();
    } else {
      delete currentFilterModel?.search;
      this.gridApi?.setFilterModel(currentFilterModel);
      this.gridApi?.onFilterChanged();
    }
    this.handlePageChange(0);
  };

  setPrinterFriendly = () => {
    const eGridDiv: any = document.getElementById('my-grid');
    eGridDiv.style.width = '';
    eGridDiv.style.height = '';
    this.gridApi && this.gridApi.setDomLayout('print');
  };

  setNormal = () => {
    const eGridDiv: any = document.getElementById('my-grid');
    eGridDiv.style.width = '600px';
    eGridDiv.style.height = '200px';
    this.gridApi && this.gridApi.setDomLayout('null');
  };

  showLoader = () => {
    return '<Loader show = {true}/>';
  };

  onSelectingRow = () => {
    if (this.gridApi) {
      const selectedRows: any = this.gridApi.getSelectedRows();
      this.setState({ selectedRows: selectedRows });
      this.props.onChange && this.props.onChange(selectedRows);
    }
  };

  // Helper function to reset all filters from the columns.
  resetAllFilters = () => {
    if (this.props.redirectToOnReset === 'job') {
      history.push('/jobs');
    }
    if (this.props.notClosed == 'notClosed') {
      history.push('/jobs');
      this.props.getJobList(null);
    }
    if (this.props.redirectToOnReset === 'candidate') {
      history.push('/candidates');
    }
    if (this.props.redirectToOnReset === 'team') {
      history.push('/team');
    }
    if (this.props.redirectToOnReset === 'expenses') {
      history.push('/timeAndExpenses/expenses');
    }
    if (this.props.redirectToOnReset === 'ContractorProjects') {
      history.push('contractorProjects?query=total');
    }
    this.setState({ quickFilterText: '', recentSearchList: [] });
    this.gridApi && this.gridApi.setFilterModel(null);
    this.props.cascadeRemoveFilters && this.props.cascadeRemoveFilters();
  };

  countFilters = () => {
    let filterCount, filters;
    let filteredRows: Array<any> = [];
    if (this.gridApi) {
      filters = this.gridApi.getFilterModel();
      filterCount = Object.keys(filters).length;
      //@ts-ignore
      filteredRows = this.getFilteredRows(this.gridApi.getModel().rootNode.childrenAfterFilter);
      this.setState({ rowCount: this.gridApi.paginationGetRowCount() });
    } else {
      filters = null;
      filterCount = 0;
    }
    this.props.cascadeFilterCount && this.props.cascadeFilterCount(filterCount, filters, filteredRows);
    this.handlePaginationFromGrid();
  };

  getFilteredRows = (childrenAfterFilter: any) => {
    const filteredRows: any[] = [];
    if (childrenAfterFilter !== undefined) {
      childrenAfterFilter.forEach((eachData: Readonly<any>) => {
        if (eachData.childrenAfterFilter === undefined) {
          filteredRows.push(eachData.data);
        } else {
          const returnedChildren = this.getFilteredRows(eachData.childrenAfterFilter);
          returnedChildren.forEach((child: Readonly<any>) => {
            filteredRows.push(child);
          });
        }
      });

      return filteredRows;
    } else {
      return filteredRows;
    }
  };

  calculateHeight(rowData: Array<any>) {
    if (this.props.height) {
      return this.props.height;
    } else {
      let len = rowData.length;
      const rowHeight = this.props.rowHeight ? this.props.rowHeight : 45;
      len = Math.max(5, len);
      const bufferValue = this.state.isActive ? 105 : 96;

      return Math.min(len * rowHeight, 10 * rowHeight) + bufferValue;
    }
  }

  onDisplayedColumnsChanged = (params: any) => {
    if (!this.state.isActive) {
      params.api.sizeColumnsToFit();
    }
  };

  setIsActive(value: boolean) {
    this.setState({ isActive: value }, () => {
      if (this.gridColumnApi && this.gridApi) {
        if (this.state.isActive) {
          this.gridColumnApi.autoSizeAllColumns();
        } else {
          const params = {
            api: this.gridApi,
            columnApi: this.gridColumnApi,
          };
          this.onDisplayedColumnsChanged(params);
        }
      }
    });
  }

  onToolPanelVisibleChanged = (params: any) => {
    if (!params.api.isToolPanelShowing() && !this.state.isActive) {
      this.onDisplayedColumnsChanged(params);
    }
  };

  cascadeQuickFilterText = (quickFilterText: string) => {
    // this.handleSearch(quickFilterText)
    this.setState({ quickFilterText });
  };

  handlePageChange(page: number) {
    this.setState({ currentPage: page }, () => {
      this.gridApi && this.gridApi.paginationGoToPage(page);
    });
    this.props.cascadeCurrentPage && this.props.cascadeCurrentPage(page);
  }

  onGridReady = (params: any) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (!this.state.isActive) this.gridApi && this.gridApi.sizeColumnsToFit();
    else this.gridApi && this.gridColumnApi && this.gridColumnApi.autoSizeAllColumns();

    if (this.props.datasource) {
      params.api.setServerSideDatasource(this.props.datasource);
    }
  };

  getFilterMethod = () => {
    if (
      (this.props.redirectToOnReset && this.props.redirectToOnReset === 'job') ||
      this.props.notClosed == 'notClosed'
    ) {
      this.filterJobsByStatus();
    }
    if (this.props.redirectToOnReset && this.props.redirectToOnReset === 'candidate') {
      this.filterCandidatesByStatus();
    }
  };

  filterJobsByStatus = () => {
    let values: Array<any> = [];
    if (this.props.role !== 'Vendor' && this.gridApi) {
      const statusFilterComponent = this.gridApi.getFilterInstance('status');
      const pendingFilterComponent = this.gridApi.getFilterInstance('can_user_approve');
      if (this.props.filterType && this.props.filterType === 'pending') {
        values = PendingJobStatus;
      } else if (this.props.filterType && this.props.filterType === 'active') {
        values = ActiveJobStatus;
      } else if (this.props.notClosed && this.props.notClosed === 'notClosed') {
        values = NotClosedJobStatus;
      }
      this.updateGridApiFilter(statusFilterComponent, values);
      if (this.props.filterType === 'pending' && (this.props.role === 'VP' || this.props.role === 'Procurement')) {
        this.updateGridApiFilter(pendingFilterComponent, ['true']);
      }
    }
  };

  filterCandidatesByStatus = () => {
    let values: Array<any> = [];
    if (this.props.newSubmissions && this.gridApi) {
      const statusFilterComponent = this.gridApi.getFilterInstance('status');
      const hmViewedFilterComponent = this.gridApi.getFilterInstance('hm_viewed');
      if (this.props.role === 'MSP' || this.props.role === 'PROCUREMENT') {
        values = this.props.query === 'preInterview' ? MspPreInterviewCandidateStatus : MspNewSubmissionCandidateStatus;

        this.updateGridApiFilter(statusFilterComponent, values);
        this.updateGridApiFilter(hmViewedFilterComponent, ['false']);
      } else {
        this.updateGridApiFilter(statusFilterComponent, ['false']);
      }
    }
    if ((this.props.role === 'HM' || this.props.role === 'VP') && this.gridApi) {
      const hmViewedFilterComponent = this.gridApi.getFilterInstance('hm_viewed');
      const statusFilterComponent = this.gridApi.getFilterInstance('status');
      if (this.props.newSubmissions) {
        this.updateGridApiFilter(hmViewedFilterComponent, ['false']);
        this.updateGridApiFilter(statusFilterComponent, ActiveCandidateStatus);
      } else {
        this.updateGridApiFilter(statusFilterComponent, ActiveCandidateStatus);
      }
    }
    if (this.props.role === 'PROCUREMENT' && this.gridApi) {
      const statusFilterComponent = this.gridApi.getFilterInstance('status');
      this.updateGridApiFilter(statusFilterComponent, ActiveCandidateStatus);
    }
    if (this.props.role === 'VENDOR' && this.gridApi) {
      const statusFilterComponent = this.gridApi.getFilterInstance('status');
      if (this.props.query === 'interview') {
        this.updateGridApiFilter(statusFilterComponent, [INTERVIEW]);
      }
      if (this.props.query === 'submitted') {
        this.updateGridApiFilter(statusFilterComponent, [APPLICANT, PRE_SCREEN, CLIENT_REVIEW]);
      }
      if (this.props.query === 'onboarding') {
        this.updateGridApiFilter(statusFilterComponent, [OFFER_ACCEPTED, ONBOARDING_PREP, ONBOARDING_FINAL]);
      }
    }
    if (this.props.role === 'MSP' && this.gridApi) {
      const decisionPendingFilterComponent = this.gridApi.getFilterInstance('offer_decision_pending');
      let statusFilterComponent = this.gridApi.getFilterInstance('status');
      if (this.props.query === 'pending_feedback') {
        this.updateGridApiFilter(decisionPendingFilterComponent, ['true']);
      } else if (this.props.query === 'interview') {
        this.updateGridApiFilter(decisionPendingFilterComponent, ['false']);
        this.updateGridApiFilter(statusFilterComponent, [INTERVIEW]);
      } else if (this.props.query === 'offer_submitted') {
        this.updateGridApiFilter(statusFilterComponent, [OFFER_EXTENDED]);
      } else if (this.props.query === 'offer_accepted') {
        this.updateGridApiFilter(statusFilterComponent, [OFFER_ACCEPTED]);
      } else if (this.props.query == 'onboarding') {
        statusFilterComponent = this.gridApi.getFilterInstance('status');
        this.updateGridApiFilter(statusFilterComponent, OnBoardingStatus);
      }
    }
    if (this.props.role === 'TL' && this.gridApi) {
      const statusFilterComponent = this.gridApi.getFilterInstance('status');
      const decisionPendingFilterComponent = this.gridApi.getFilterInstance('offer_decision_pending');

      if (this.props.query === 'interview') {
        this.updateGridApiFilter(statusFilterComponent, [INTERVIEW]);
        this.updateGridApiFilter(decisionPendingFilterComponent, ['false']);
      } else if (this.props.query === 'pending_feedback') {
        this.updateGridApiFilter(decisionPendingFilterComponent, ['true']);
      }
    }
  };

  filterTeamByStatus = () => {
    if (this.gridApi && this.props.query == 'active') {
      const statusFilterComponent = this.gridApi.getFilterInstance('status');
      this.updateGridApiFilter(statusFilterComponent, HMVPActiveContractorStatus);
    }
  };

  getPaginationCount = () => {
    if (this.props.datasource) {
      return this.props.rowCount ?? 0;
    } else {
      return this.state.rowCount !== -1 && this.state.rowCount < this.state.rowData.length
        ? this.state.rowCount
        : this.state.rowData.length;
    }
  };

  onFirstDataRendered = () => {
    this.getFilterMethod();
    if (this.props.savedFilters) {
      this.props.savedFilters.forEach((eachFilter: Readonly<any>) => {
        if (this.props.applyFilter === eachFilter.name) {
          const filter = {
            label: eachFilter.name,
            value: eachFilter.name,
          };
          this.handleFilterChange(filter, this.props.savedFilters);
        }
      });
    }
  };

  handleFilterChange = (value: any, savedFilters: any) => {
    this.setState({ filterValue: value });
    if (this.gridApi && this.gridColumnApi) {
      let filter: any = null;
      savedFilters.forEach((eachSavedFilter: Readonly<any>) => {
        if (eachSavedFilter.name === value.value) {
          filter = eachSavedFilter.appliedFilters;
        }
      });
      if (filter) {
        const existingGroupedColumns = this.gridColumnApi.getRowGroupColumns();
        existingGroupedColumns.forEach((eachGroupedColumn: Readonly<any>) => {
          this.gridColumnApi?.removeRowGroupColumn(eachGroupedColumn.colId);
        });
        this.gridApi.setFilterModel(filter.filterModel);
        this.gridApi.setSortModel(filter.sortModel);
        filter.groupModel.forEach((eachGroupedColumn: Readonly<any>) => {
          this.gridColumnApi?.addRowGroupColumn(eachGroupedColumn.colId);
        });
        if (filter.columnModel) {
          this.gridColumnApi.setColumnState(filter.columnModel);
        }
      }
    }
  };

  updateGridApiFilter(statusFilterComponent: any, values: any) {
    if (statusFilterComponent && values) {
      statusFilterComponent.setModel({
        type: 'set',
        values: values,
      });
      this.gridApi?.onFilterChanged();
    }
  }

  handlePaginationFromGrid() {
    let rowsOnPage = this.state.rowData.length;
    rowsOnPage = this.props.paginationPageSize > 0 ? this.props.paginationPageSize : rowsOnPage;
    this.setState({ rowsOnPage });
  }

  handleGrouping = () => {
    if (this.gridApi && this.gridColumnApi) {
      this.setState({ rowCount: this.gridApi.paginationGetRowCount() });
    }
  };

  handleCsvExport = async (params: any, userDetails: any) => {
    if (this.props.logUserExport) {
      Sentry.captureMessage(`Export as CSV action by user - ${userDetails}`, Severity.Info);
    }
    params.api.exportDataAsCsv({
      processCellCallback: this.props.hasNoDatesToFormat
        ? undefined
        : function (cell: ProcessCellForExportParams) {
            const colId = cell.column.getColId();

            if (colId.includes('date')) {
              return cell.value ? moment(cell.value).local().format('MM/DD/YYYY') : '';
            }

            return cell.value;
          },
      processHeaderCallback: function (cell: ProcessHeaderForExportParams) {
        return cell.column.getColDef().headerName;
      },
    });
  };

  handleExcelExport = async (params: any, userDetails: any) => {
    if (this.props.logUserExport) {
      Sentry.captureMessage(`Export as Excel action by user - ${userDetails}`, Severity.Info);
    }
    params.api.exportDataAsExcel({
      processCellCallback: this.props.hasNoDatesToFormat
        ? undefined
        : function (cell: ProcessCellForExportParams) {
            const colId = cell.column.getColId();

            if (colId.includes('date')) {
              return cell.value ? moment(cell.value).local().format('MM/DD/YYYY') : '';
            }

            return cell.value;
          },
      processHeaderCallback: function (cell: ProcessHeaderForExportParams) {
        return cell.column.getColDef().headerName;
      },
    });
  };

  getContextMenuItems = (params: any, that: any) => {
    const userInfo = that.props.userData;
    let userDetails = '';
    if (userInfo) {
      userDetails = `Role: ${userInfo.loggedInUserRole}, Name: ${userInfo.loggedInUserFirstname} ${userInfo.loggedInUserLastname} `;
    }

    const options = [
      {
        name: 'Export as CSV',
        action: () =>
          this.props.excelExport
            ? this.props.excelExport(
                params.api.getFilterModel(),
                params.api.getSortModel(),
                params.api.paginationProxy.masterRowCount,
                false,
              )
            : this.handleCsvExport(params, userDetails),
      },
      {
        name: 'Export as Excel',
        action: () =>
          this.props.excelExport
            ? this.props.excelExport(
                params.api.getFilterModel(),
                params.api.getSortModel(),
                params.api.paginationProxy.masterRowCount,
                true,
              )
            : this.handleExcelExport(params, userDetails),
      },
      'copy',
      'copyWithHeaders',
    ];

    return options;
  };

  render() {
    const {
      width,
      classes,
      isSideBarRequired,
      isSearchRequired,
      filterCount,
      paperElevation,
      autoSizeColumns,
      rowGroupPanelShow,
      datasource,
    } = this.props;
    const {
      columnDefs,
      modules,
      rowData,
      quickFilterText,
      rowsOnPage,
      hideSearchBar,
      selectedRows,
      currentPage,
      rowCount,
      isActive,
    } = this.state;
    const totalSelected = selectedRows.length;

    const cloneProps = (({ datasource, ...props }) => props)(this.props);

    return (
      <Grid container className={classes.parent}>
        {!this.state.hideSearchBar && (
          <Grid item xs={12} className={classNames(classes.searchContainerFlexBox, hideSearchBar && classes.hide)}>
            <Grid container alignItems="center" justify="space-between">
              <Grid item xs={5} className={classes.search}>
                <SearchBar
                  cascadeQuickFilterText={datasource ? null : _.debounce(this.cascadeQuickFilterText, 500)}
                  handleElasticInput={datasource ? this.handleDataSourceElasticInput : null}
                  placeholder={this.props.searchPlaceholder}
                />
              </Grid>
              {this.props.action && <Grid item>{this.props.action}</Grid>}
            </Grid>
          </Grid>
        )}
        <Grid item container>
          {!this.props.viewAll ? (
            <Grid item xs={9}>
              {this.props.displayQuickActions &&
                (this.state.selectedRows.length > 0 ? (
                  <Grid item xs={12} className={classes.quickActionSpace}>
                    <Grid container alignItems="center">
                      <Grid item>
                        <TnTypography variant="subtitle2" className={classes.totalSelected}>
                          {' '}
                          {totalSelected} Selected{' '}
                        </TnTypography>
                      </Grid>
                      <Grid item className={classes.iconList} xs={9}>
                        <QuickActionButton icons={this.state.iconList} />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid item xs={12}>
                    <Grid container alignItems={'center'} className={classes.quickActionSpace}>
                      <Grid item>
                        {filterCount !== undefined && (
                          <FilterCount
                            filterCount={filterCount === -1 ? 0 : filterCount}
                            resetAllFilters={this.resetAllFilters}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
            </Grid>
          ) : (
            <Grid item container justify="space-between" alignItems={'center'}>
              <Grid item xs={9}>
                {this.props.displayQuickActions &&
                  (this.state.selectedRows.length > 0 ? (
                    <Grid item xs={12} className={classes.quickActionSpace}>
                      <Grid container alignItems="center">
                        <Grid item>
                          <TnTypography variant="subtitle2" className={classes.totalSelected}>
                            {' '}
                            {totalSelected} Selected{' '}
                          </TnTypography>
                        </Grid>
                        <Grid item className={classes.iconList} xs={9}>
                          <QuickActionButton icons={this.state.iconList} />
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid item xs={12}>
                      <Grid container alignItems={'center'} className={classes.quickActionSpace}>
                        <Grid item>
                          {filterCount !== undefined && (
                            <FilterCount
                              filterCount={filterCount === -1 ? 0 : filterCount}
                              resetAllFilters={this.resetAllFilters}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
              </Grid>
            </Grid>
          )}
          {this.props.isAutoSizeToggleRequired && (
            <Grid item container justify={'flex-end'} alignItems={'center'} xs={3}>
              <Grid item>
                <TnTypography variant="subtitle2">Auto-Size All</TnTypography>
              </Grid>
              <Grid item>
                <Switch
                  checked={isActive}
                  onChange={(event: any) => this.setIsActive(event.target.checked)}
                  value={isActive}
                  // disabled={!isEdit}
                  color="primary"
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
        <Paper elevation={paperElevation !== null ? paperElevation : 2} style={{ width: '100%' }}>
          <Grid item xs={12}>
            <div className={'ag-theme-material'} style={{ width: width, height: this.calculateHeight(rowData) }}>
              <AgGridReact
                getRowNodeId={(params: any) => params?.id}
                gridOptions={{
                  getContextMenuItems: (params) => this.getContextMenuItems(params, this),
                }}
                modules={modules}
                columnDefs={columnDefs}
                {...cloneProps}
                onGridReady={this.onGridReady}
                onFirstDataRendered={this.onFirstDataRendered}
                onDisplayedColumnsChanged={this.onDisplayedColumnsChanged}
                onColumnRowGroupChanged={(params) => {
                  this.setState({
                    groupByColumnsCount: params.columnApi.getRowGroupColumns().length,
                  });
                  params.columnApi.getRowGroupColumns().length > 0
                    ? this.setIsActive(true)
                    : this.setIsActive(
                        this.props.isHorizontalScrollRequired ? this.props.isHorizontalScrollRequired : false,
                      );
                  this.handleGrouping();
                }}
                onColumnResized={() => this.gridApi?.resetRowHeights()}
                onToolPanelVisibleChanged={this.onToolPanelVisibleChanged}
                rowData={rowData}
                rowBuffer={50}
                suppressRowClickSelection={true}
                onSortChanged={(event: any) => {
                  this.props.onSortChanged?.(event);
                }}
                onSelectionChanged={this.onSelectingRow}
                rowHeight={this.props.rowHeight ? this.props.rowHeight : 45}
                headerHeight={45}
                quickFilterText={isSearchRequired === false ? this.props.quickFilterText : quickFilterText}
                cacheQuickFilter={true}
                paginationPageSize={rowsOnPage ? rowsOnPage : rowData.length}
                sideBar={!isSideBarRequired && isSideBarRequired != undefined ? null : this.state.sideBar}
                rowGroupPanelShow={rowGroupPanelShow}
                defaultColDef={this.state.defaultColumnDefs}
                autoGroupColumnDef={this.state.autoGroupColumnDef}
                rowSelection={this.props.singleSelect ? 'single' : 'multiple'}
                rowMultiSelectWithClick={true}
                groupDefaultExpanded={
                  this.props.expand
                    ? this.state.groupByColumnsCount + 1
                    : this.props.datasource
                      ? undefined
                      : this.state.groupByColumnsCount
                }
                groupMultiAutoColumn={true}
                groupSelectsChildren={true}
                suppressDragLeaveHidesColumns={true}
                suppressMakeColumnVisibleAfterUnGroup={false}
                suppressPaginationPanel
                suppressColumnVirtualisation={true}
                isRowSelectable={this.props.isRowSelectable ? this.props.isRowSelectable : () => true}
                onFilterChanged={() => {
                  this.countFilters();
                }}
                animateRows={true}
                domLayout="normal"
                pivotMode={false}
                serverSideStoreType={ServerSideStoreType.Partial}
                rowModelType={datasource ? 'serverSide' : 'clientSide'}
                cacheBlockSize={datasource ? rowsOnPage : undefined}
                pagination={true}
                immutableData={this.props.immutableData}
              ></AgGridReact>
            </div>
          </Grid>
        </Paper>
        {this.props.pagination && (
          <div
            style={{ width: '100%', marginTop: '10px' }}
            className={this.props.viewAll ? classes.paginationContainer : ''}
          >
            {this.props.viewAll && (
              <TnButton
                className={classes.buttonText}
                variant={'outlined'}
                color={'secondary'}
                onClick={this.props.handleViewAll}
                value={'View All'}
              ></TnButton>
            )}
            <Grid container alignItems="center" justify="flex-end">
              <Grid item>
                {this.props.count && rowData.length ? (
                  <TnTypography variant="subtitle2">
                    {rowData.length} of {this.props.count}{' '}
                    {rowData.length < this.props.count && (
                      <span
                        className={classes.fetchall}
                        onClick={() => {
                          this.props.handleFetchAll();
                          this.setState({ rowCount: -1 });
                        }}
                      >
                        Fetch All
                      </span>
                    )}
                  </TnTypography>
                ) : (
                  <Grid></Grid>
                )}
              </Grid>
              <Grid item>
                {this.props.pagination && (
                  <TablePagination
                    component={'div'}
                    count={this.getPaginationCount()}
                    ActionsComponent={TnAgGridPaginationActions}
                    onChangePage={(event, page) => this.handlePageChange(page)}
                    onChangeRowsPerPage={(event) => this.handleChange(event.target.value)}
                    page={currentPage}
                    rowsPerPageOptions={this.props?.rowsPerPageOptions}
                    rowsPerPage={rowsOnPage}
                    className={classes.rowsPerPage}
                  />
                )}
              </Grid>
            </Grid>
          </div>
        )}
      </Grid>
    );
  }
}

export default withStyles(() => ({
  selectedGrid: {
    paddingBottom: '1.3%',
  },
  selectedGridText: {
    textAlign: 'right',
    fontSize: '100%',
  },
  parent: {
    position: 'relative',
  },
  IconButton: {
    fontSize: '90%',
    padding: '0px',
  },
  EditButton: {
    fontSize: '95%',
  },
  centerAlign: {
    textAlign: 'center',
    paddingLeft: '20px',
  },
  searchGrid: {
    width: 300,
  },
  dropDown: {
    textAlign: 'right',
  },
  rightAlign: {
    textAlign: 'right',
  },
  tableHeader: {
    marginTop: 10,
    marginBottom: 6,
  },
  totalSelected: {
    // marginLeft: 4,
    // marginTop: 20,
    // marginRight: 25,
    // width: 80
  },
  dot: {
    height: 10,
    width: 10,
    display: 'inline-block',
    borderRadius: '50%',
    backgroundColor: '#FFCE62',
    marginLeft: 4,
    marginTop: 20,
  },
  quickActionSpace: {
    height: 58,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconList: {
    display: 'inline-block',
    // marginTop: 20,
    paddingLeft: '25px',
  },
  input: {
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
    border: '1px solid #ced4da',
    width: '100px',
  },
  search: {
    // height: 100
  },
  menuItem: {
    height: '8px',
    backgroundColor: '#FFFFFF',
    textAlign: 'center',
  },
  recentSearchContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
    marginTop: '2px',
    marginBottom: '14px',
    width: 300,
  },
  searchContainerFlexBox: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '14px',
    marginTop: '14px',
  },
  hide: {
    display: 'none',
  },
  emptySpace: {
    height: 60,
  },
  totalRowsSelected: {
    opacity: 0.25,
    fontFamily: 'Avenir',
    fontSize: '12px',
    lineHeight: '16px',
    paddingLeft: '10px',
  },
  reset: {
    // marginLeft: 15
  },
  resetIcon: {
    height: 20,
    width: 20,
  },
  viewAllLink: {
    paddingTop: '26px',
    cursor: 'pointer',
  },
}))(TNAGGrid);
